import { render, staticRenderFns } from "./settingCT.vue?vue&type=template&id=bc249c48&scoped=true&"
import script from "./settingCT.vue?vue&type=script&lang=js&"
export * from "./settingCT.vue?vue&type=script&lang=js&"
import style0 from "./settingCT.vue?vue&type=style&index=0&id=bc249c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc249c48",
  null
  
)

export default component.exports